<template>
  <div>
    <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Supplier Invoices
                  </h4>
              </div><!--col-->
              <div class="col-sm-7">
                  <header-button></header-button>
              </div><!--col-->
          </div><!--row-->
          <hr />
          <div class="row mt-4">
            <div class="col-sm-6">
              <h5 class="mb-3">{{ $t('supplier.invoice.label.filter_option') }}</h5>
              <b-form v-if="show">
                <div class="form-group row">
                  <label for="" class="col-sm-3 col-form-label">{{ $t('supplier.invoice.label.invoice_date') }}</label>
                  <div class="col-sm-9 row">
                    <div class="col-sm-6 form-row">
                      <datepicker v-model="filter.uploadDateFrom" :format="customFormatter" input-class="form-control"></datepicker>
                    </div>
                    <div class="col-sm-6 form-row">
                      <datepicker v-model="filter.uploadDateTo" :format="customFormatter" input-class="form-control"></datepicker>
                    </div>
                  </div>
                </div>
                <b-form-fieldset
                  :label="$t('supplier.invoice.label.invoice_no')"
                  :description="$t('supplier.invoice.label.please_enter_invoice_no')"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input type="text" v-model="filter.invoiceNo" :placeholder="$t('supplier.invoice.label.enter_invoice_no')"></b-form-input>
                </b-form-fieldset>
                <b-form-fieldset
                  :label="$t('supplier.invoice.label.tracking_no')"
                  :description="$t('supplier.invoice.label.please_enter_tracking_no')"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input type="text" v-model="filter.trackingNo" :placeholder="$t('supplier.invoice.label.enter_tracking_no')"></b-form-input>
                </b-form-fieldset>
                <b-button type="button" size="sm" variant="primary" @click="onSearchForm"><i class="fa fa-search"></i> {{ $t('supplier.invoice.label.search') }}</b-button>
                <b-button type="reset" size="sm" variant="danger ml-1" @click="onReset"><i class="fa fa-ban"></i> {{ $t('supplier.invoice.label.reset') }}</b-button>
              </b-form>
            </div><!--col-->
          </div>
          <div class="row mt-4">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <colgroup>
                          <col width="10%">
                          <col width="10%">
                          <col width="20%">
                          <col width="10%">
                          <col width="10%">
                          <col width="10%">
                          <col width="10%">
                          <col width="10%">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>{{ $t('supplier.invoice.label.supplier') }}</th>
                            <th>{{ $t('supplier.invoice.label.invoice_no') }}</th>
                            <th>{{ $t('supplier.invoice.label.description') }}</th>
                            <th>{{ $t('supplier.invoice.label.date') }}</th>
                            <th>{{ $t('supplier.invoice.label.due_date') }}</th>
                            <th>{{ $t('supplier.invoice.label.total_amount') }}</th>
                            <th>{{ $t('supplier.invoice.label.status') }}</th>
                            <th>{{ $t('supplier.invoice.label.operation') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(supplierInvoice, index) in supplierInvoices" :key="index">
                            <td>{{ supplierInvoice.supplier.primary_name }}</td>
                            <td>
                              <router-link :to="{ path: '/supplier-invoice/' + supplierInvoice.id +'/edit' }">{{ supplierInvoice.invoice_no }}</router-link>
                            </td>
                            <td>{{ supplierInvoice.description }}</td>
                            <td>{{ supplierInvoice.date }}</td>
                            <td>{{ supplierInvoice.due_date }}</td>
                            <td>{{ supplierInvoice.total_amount }}</td>
                            <td v-html="supplierInvoice.status_label"></td>
                            <td>
                              <router-link :to="{ path: '/supplier-invoice/' + supplierInvoice.id +'/edit' }">
                                <b-button variant="info ml-1" size="sm"><i class="fa fa-pencil"></i></b-button>
                              </router-link>
                              <b-button size="sm" v-if="supplierInvoice.pdf" variant="success ml-1" @click.stop.prevent="downloadInvoicePDF(supplierInvoice.id, supplierInvoice.invoice_no)"><i class="fa fa-print"></i></b-button>
                              <CButton size="sm" color="warning" @click.stop.prevent="handleShowNoteModal(supplierInvoice.id)" class="ml-1"><i class="fa fa-sticky-note-o"></i></CButton>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="row">
                        <div class="col-sm-12 col-md-5">
                          <div class="mt-2" aria-live="polite">{{ $t('general.list.display') }} {{ this.meta.from }} {{ $t('general.list.to') }} {{ this.meta.to }} {{ $t('general.list.of') }} {{ this.meta.total }} {{ $t('general.list.records') }}</div>
                        </div>
                        <div class="col-sm-12 col-md-7">
                          <nav>
                            <b-pagination align="end" :total-rows="this.meta.total" :per-page="this.meta.per_page" v-model="currentPage" :prev-text="$t('general.list.prev')" :next-text="$t('general.list.next')" @change='changePage' hide-goto-end-buttons/>
                          </nav>
                        </div>
                      </div>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
  </div><!--card-->
  <CModal
      v-if="currentInvoiceId"
      title="Suppier Invoice Note List"
      :show.sync="showNoteModal"
      color="primary"
      size="xl"
    >
      <note-list  noteableType="supplier_invoices" :noteableId="currentInvoiceId"></note-list>
    </CModal>
  </div>
</template>

<script>
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import HeaderButton from '@/views/components/supplier/invoice/HeaderButton'
import NoteList from '@/components/NoteList.vue'

export default {
  name: 'DelieryOrders',
  components: {
    HeaderButton,
    NoteList,
    datepicker
  },
  mounted () {
    this.fetchSupplierInvoices()
  },
  data () {
    return {
      showNoteModal: false,
      currentInvoiceId: undefined,
      supplierInvoices: [],
      meta: [],
      filter: {
        uploadDateFrom: '',
        uploadDateTo: '',
        invoiceNo: '',
        trackingNo: ''
      },
      currentPage: 1,
      show: true,
    }
  },
  methods: {
    fetchSupplierInvoices () {
      this.axios.get('/supplier-invoice').then(response => {
        this.supplierInvoices = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    },
    onReset () {
      // evt.preventDefault()
      this.filter.invoiceNo = ''
      this.filter.trackingNo = ''
      this.filter.uploadDateFrom = moment().format('YYYY-MM-DD')
      this.filter.uploadDateTo = moment().add(1, 'day').format('YYYY-MM-DD')
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    onSearchForm () {
      this.axios.get('/supplier-invoice', {
        params: {
          invoice_no: this.filter.invoiceNo,
          tracking_no: this.filter.trackingNo,
          date_from: this.filter.uploadDateFrom,
          date_to: this.filter.uploadDateTo
        }
      }).then(response => {
        this.supplierInvoices = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    },
    changePage (pageNum) {
      this.axios.get('/supplier-invoice', {
        params: {
          invoice_no: this.filter.invoiceNo,
          tracking_no: this.filter.trackingNo,
          date_from: this.filter.uploadDateFrom,
          date_to: this.filter.uploadDateTo,
          page: pageNum
        }
      }).then(response => {
        this.supplierInvoices = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    },
    downloadInvoicePDF (invoiceId, invoiceNo) {
      this.axios.get('/supplier-invoice/'+invoiceId+'/download-pdf', {
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = invoiceNo + '.pdf'
        link.click()
      }).catch(error => {
        console.log(error)
      })
    },
    handleShowNoteModal: async function ( value) {
      this.currentInvoiceId = value
      await this.$nextTick()
      // console.log(this.$el.textContent) // => '已更新'
      this.showNoteModal = true
    }
  }
}
</script>
